import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import { Base64 } from "js-base64"
import { SearchPreference } from "../../payment/listing/types"
import { INTEGRATION_KEY } from "../integration/Constants"
import { SearchPayload } from "../search/SearchPayload"
import { PREFERENCE_TYPE } from "./constants"


export class ListingHelper {

    static async getListingPreferences(preference_type: PREFERENCE_TYPE) {
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        const preferences = await AppContext.getApiClient().get(url)

        return JSON.parse(Base64.decode(preferences.attributes[preference_type]))
    }

    static saveListingPreferences(preference_type: PREFERENCE_TYPE, preferences: SearchPayload | SearchPreference) {
        const url = "/users/" + AppContext.getUserLoggedIn().id + "/preferences"
        
        return AppContext.getApiClient().patch(url, {
            [preference_type]: Base64.encode(JSON.stringify(preferences))
        })
    }


    static batchExport = (objectType: string, filters: SearchPayload) => AppContext.getApiClient().post("/batch-exports", {
        integrationKey: INTEGRATION_KEY.CSV,
        type: objectType,
        filters: filters,
    }).then(res => {
        if (res.error) {
            return res as Error
        }
        return res
    })

}

export default ListingHelper


// WEBPACK FOOTER //
// ./src/state/listing/ListingHelper.ts